// alternative-dashboard\alternative-components\compactWidgetsCardDetails\QuickActionsWidget.tsx
import QuickActionsGrid from "../QuickActionsGrid";
import "./styles/CompactWidgets.scss";

interface QuickActionsWidgetProps {
  title?: string;
}

function QuickActionsWidget({ title }: QuickActionsWidgetProps) {
  return (
    <div className="gx-quick-actions-widget">
      <div className="gx-quick-actions-header">
        <h1 className="gx-p18-b">{title || "Quick Actions"}</h1>
        <QuickActionsGrid variant="menu" />
      </div>
    </div>
  );
}

export default QuickActionsWidget;
